import UserApi from './user-api';

class ClinikoApi {
    static async validateKey(bearerToken, apiKey) {
        return UserApi.validateClinikoKey(bearerToken, apiKey);
    }

    static async getPatientDetails(bearerToken, patientId) {
        return UserApi.getClinikoPatientDetails(bearerToken, patientId);
    }

    static async getPatientAppointments(bearerToken, patientId) {
        return UserApi.getClinikoPatientAppointments(bearerToken, patientId);
    }

    static async getTreatmentNoteTemplates(bearerToken) {
        return UserApi.getClinikoTreatmentNoteTemplates(bearerToken);
    }

    static async addNote(bearerToken, payload) {
        return UserApi.addClinikoNote(bearerToken, payload);
    }
}

export default ClinikoApi;
